import { useEffect, useState, useContext, useRef} from 'react'
import axios from 'axios'
import fileDownload from 'js-file-download'

import './css/Home.css'
import manSrc from '../images/man.png'
import stSrc from '../images/st3.png'
import { AppContext } from "../Context";
import Fetch, { Loader } from "../inc/Fetch";
import { useParams } from 'react-router-dom'
import ErrorPage from './ErrorPage'
import { Config } from '../inc/Config'



export default function DownloadFile() {

	const params = useParams();
	const [loader, setloader] = useState(true);
	const [error, seterror] = useState(false);


	function loadData() { 

		Fetch("downloadFile", (d) => {
			
			if (d?.error) {
				seterror(d?.error);
			} else {

				let ext = d?.file?.split(".")?.pop();

				axios.get(`${Config?.imgUrl}${d?.file}`, {
					responseType: 'blob',
				})
				.then((res) => {
					fileDownload(res.data, `file.${ext}`)
				})
			}
			
			setloader(false);
		}, params);


		// axios.get(url, {
		// 	responseType: 'blob',
		// })
		// .then((res) => {
		// 	fileDownload(res.data, filename)
		// })
	}

	useEffect(() => {
		loadData()
	}, []);

	if (loader) {
		return (<Loader />);
	}

	return (
		
		<>
			{error && <ErrorPage short={error}/>}
			{/* <a onClick={() => handleDownload(`${Config?.domain}`)}>asdasdasdasdasd</a> */}
		</>
	)
}
